import { css } from '@emotion/react';
import { colors } from './colorPalette';

export const documentContainer = (isRoot) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    align-items: center;
    background-color: ${isRoot ? colors.primary.main : colors.semantic.white};
    color: ${isRoot ? colors.primary.contrast : colors.semantic.black};
    // overflow-x: hidden;
`;

export const mainContainer = css`
    display: flex;
    width: 100%;
    justify-content: center;
    flex: 1;
    overflow-x: hidden;
`;
